"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFlexTableColumn = exports.CrudTable = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const components_1 = require("@rws-framework/components");
Object.defineProperty(exports, "IFlexTableColumn", { enumerable: true, get: function () { return components_1.IFlexTableColumn; } });
const backendImport_1 = require("@front/backendImport");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
const component_1 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("../../services/PopupService"));
const AccountLimitService_1 = __importStar(require("../../services/AccountLimitService"));
const component_2 = require("../site-menu/component");
const events_1 = require("@rws-framework/components/src/components/rws/table-controls/events");
//@ts-ignore                
let rwsTemplate = T.html `<div class="row">
  <div class="tables col-12">

    <div class="mb-2">
      <h1>${x => x.title.t()}</h1>
      <div class="text-zero top-right-button-container">
        <slot id="crud-extra-buttons" name="extra-buttons"></slot>
        ${(0, fast_element_1.when)(x => x.canAdd && !x.limitReached && !x.noAdd, (0, fast_element_1.html) `
          <button @click="${(x, c) => x.navigateToAdd()}"
            class="top-right-button mr-1 btn btn-primary btn-lg">${x => x.addText ? x.addText.t() : 'crud.create'.t()}</button>
        `)}
        ${(0, fast_element_1.when)(x => x.limitReached, (0, fast_element_1.html) `
          <rws-tooltip text="${x => x.limitTooltip}" side="left">
            <button disabled
              class="top-right-button mr-1 btn btn-secondary btn-lg">${x => x.addText ? x.addText.t() : 'crud.create'.t()}</button>
          </rws-tooltip>
        `)}
      </div>
    </div>
    <div class="crud-table-container">
      ${(0, fast_element_1.when)(x => x.showSearch, (0, fast_element_1.html) `
      <div class="mb-2">
        <button type="button" class="pt-0 pl-0 d-inline-block d-md-none btn btn-empty">
          ${'crud.filtering'.t()}
          <i class="simple-icon-arrow-down align-middle"></i>
        </button>
        <div id="displayOptions">
          <search-filter :placeholder="${'crud.searchPlaceholder'.t()}"
            :queryParam="${x => x.queryParam}" :searchQuery="${x => x.searchQuery}">
          </search-filter>
          <slot name="custom-filters"></slot>
        </div>
      </div>
      `)}

      <div class="company-table-container">
        ${(0, fast_element_1.when)(x => x.ready, (0, fast_element_1.html) `<rws-table 
          exportLabel="${'table.controls.export'.t()}"
          columnsLabel="${'table.controls.columns'.t()}"
          :columns="${x => x.columns}" 
          :data="${x => x.data}" 
          :actions="${x => x.actions}"
          :actionFilter="${x => x.actionsFilter}"
          emptyLabel="${x => x.effectiveEmptyMessage}">
            <slot name="table-content"></slot>
        </rws-table>`)}
        
        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}
      </div>

      ${(0, fast_element_1.when)(x => x.showPagination && !x.loading && x.data && x.data.length, (0, fast_element_1.html) `
      <app-pagination :currentPage="${x => x.currentPage}" :totalPages="${x => x.totalPages}"
        :perPage="${x => x.perPage}" :totalItems="${x => x.totalCount}" :onPageChange="${x => x.handlePageChanged}"
        @page-change="${(x, c) => x.handlePageChanged(c.event.detail)}">
      </app-pagination>
      `)}
    </div>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.company-table-container {
  width: 100%;
  position: relative;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.loading-container .spinner-border {
  width: 3rem;
  height: 3rem;
  color: #922c88;
}

.company-table {
  margin-bottom: 0;
}
.company-table thead th {
  background-color: #f8f9fa;
  color: #495057;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
  vertical-align: middle;
}
.company-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.company-table tbody td {
  vertical-align: middle;
}
.company-table tbody td .badge {
  font-size: 0.75rem;
  margin-right: 0.25rem;
}
.company-table tbody td .badge:last-child {
  margin-right: 0;
}
.company-table tbody td .badge.badge-secondary {
  background-color: #6c757d;
}
.company-table tbody td .badge.badge-success {
  background-color: #28a745;
}
.company-table tbody td .badge.badge-danger {
  background-color: #dc3545;
}

.action-buttons {
  white-space: nowrap;
}
.action-buttons .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  margin-right: 0.25rem;
}
.action-buttons .btn:last-child {
  margin-right: 0;
}
.action-buttons .btn i {
  font-size: 0.75rem;
}

.empty-state .alert {
  margin-bottom: 0;
  padding: 2rem;
  background-color: #f8f9fa;
  border-color: #dee2e6;
  color: #6c757d;
}

.top-right-button-container {
  display: flex;
  gap: 10px;
}

#displayOptions {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .company-table {
    font-size: 0.875rem;
  }
  .company-table th, .company-table td {
    padding: 0.5rem;
  }
  .company-table .action-buttons .btn {
    padding: 0.125rem 0.25rem;
    font-size: 0.75rem;
    margin-right: 0.125rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let CrudTable = class CrudTable extends client_1.RWSViewComponent {
    constructor(popupService, accountLimitService) {
        super();
        this.popupService = popupService;
        this.accountLimitService = accountLimitService;
        this.title = '';
        this.queryParam = 'q';
        this.showSearch = true;
        this.showPagination = true;
        this.searchPlaceholder = 'Search...';
        this.indexEndpoint = '';
        this.listEndpoint = '';
        this.deleteEndpoint = '';
        this.editRoute = '';
        this.addRoute = '';
        this.previewRoute = '';
        this.addText = '';
        this.emptyMessage = '';
        this.autoLoad = true;
        this.data = [];
        this.loading = false;
        this.searchQuery = '';
        this.currentPage = 1;
        this.totalPages = 1;
        this.perPage = 20;
        this.customQueryParams = {};
        this.isInitializing = true;
        this.isComponentReady = false;
        this.canEdit = true;
        this.canDelete = true;
        this.canAdd = false;
        this.noAdd = false;
        this.ready = true;
        this.limitReached = false;
        this.limitTooltip = '';
        // Table configuration
        this.columns = [];
        this.actions = [];
        // Column visibility management
        this.visibleColumns = [];
        this.pageParam = 'p';
        this.perPageParam = 'per_page';
        this.blockAdd = 'false';
        this.actionsFilter = (action, row) => {
            if (this.forceItemEditable !== undefined && this.forceItemEditable(action.key, row)) {
                return true;
            }
            return this.isItemUneditable === undefined ? true : !this.isItemUneditable(action.key, row);
        };
        // Ensure isInitializing is true from the start to prevent early property change loads
        this.isInitializing = true;
        this.isComponentReady = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.isComponentReady = true;
        this.setupActions();
        this.initializeVisibleColumns();
        this.setupTableControls();
        this.setupEventListeners();
        this.canAdd = component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN || (0, acl_helpers_1.checkACL)(`${this.resource}.${backendImport_1.ACL.aclActions.write}`, component_1.DefaultLayout.USER.acl);
        if (this.blockAdd === 'true') {
            this.canAdd = false;
        }
        this.on('rwstable.data.loaded', (event) => {
            if (this.data.length && this.onDataLoaded) {
                this.onDataLoaded(this.data, this.totalPages, this.$('rws-table'));
            }
        });
        if (this.defaultQ) {
            this.searchQuery = this.defaultQ;
        }
        // Mark initialization as complete and load data if needed
        this.isInitializing = false;
        // Only auto-load if we don't have external data and autoLoad is true
        if (this.autoLoad && (!this.data || this.data.length === 0)) {
            this.loadData();
        }
        this.checkAccountLimits();
    }
    setupEventListeners() {
        // Only set up internal event handlers if autoLoad is enabled
        // When autoLoad=false, parent component manages all data loading
        if (!this.autoLoad) {
            return;
        }
        // Listen for search events
        this.on('search-changed', (event) => {
            this.searchQuery = event.detail.query;
        });
        this.on('search-submit', (event) => {
            this.searchQuery = event.detail.query;
            this.currentPage = 1; // Reset to first page when searching
            this.loadData();
        });
        this.on(events_1.TableControlsEvents.TABLE_REFRESH, () => {
            this.loadData();
        });
    }
    handlePageChanged(page) {
        // Ensure page is a valid number
        const pageNum = Number(page);
        console.log('[CRUD-TABLE] handlePageChanged called:', {
            originalPage: page,
            convertedPage: pageNum,
            currentPage: this.currentPage,
            isInitializing: this.isInitializing,
            autoLoad: this.autoLoad
        });
        if (isNaN(pageNum) || this.currentPage === pageNum || this.isInitializing) {
            console.warn('[CRUD-TABLE] Skipping page change - invalid or duplicate page:', pageNum);
            return; // Prevent duplicate calls and calls during initialization
        }
        // Don't handle page changes when autoLoad is disabled - parent manages pagination
        if (!this.autoLoad) {
            console.log('[CRUD-TABLE] Skipping page change - autoLoad disabled');
            return;
        }
        this.currentPage = pageNum;
        this.loadData();
        if (this.onPageChanged) {
            this.onPageChanged(this.currentPage);
        }
    }
    async loadData() {
        // Prevent loading during initialization unless explicitly needed
        if (this.isInitializing) {
            return;
        }
        // Prevent loading if autoLoad is disabled and external data management is expected
        if (!this.autoLoad) {
            return;
        }
        this.loading = true;
        const endpoint = this.listEndpoint;
        let routeOptions = undefined;
        if (this.searchQuery) {
            routeOptions = {
                routeParams: { [this.queryParam]: this.searchQuery }
            };
        }
        if (this.currentPage !== null) {
            if (routeOptions === undefined) {
                routeOptions = {};
            }
            if (this.showPagination) {
                routeOptions.queryParams = {
                    [this.pageParam]: this.currentPage.toString(),
                    [this.perPageParam]: this.perPage.toString(),
                    ...this.customQueryParams
                };
            }
        }
        else if (Object.keys(this.customQueryParams).length > 0) {
            if (routeOptions === undefined) {
                routeOptions = {};
            }
            routeOptions.queryParams = { ...this.customQueryParams };
        }
        try {
            const response = await this.apiService.back.get(endpoint, routeOptions);
            if (response && response.success && Array.isArray(response.data)) {
                this.data = response.data;
                this.$emit('crud-table:data-loaded', this.data);
                this.totalPages = Math.max(1, Math.ceil(response.count / this.perPage));
                // Refresh limit checks after data is loaded
                this.checkAccountLimits();
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'crud.failedToLoad'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('crud.failedToLoad'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async deleteItem(id) {
        if (!await this.popupService.confirm('crud.confirmDelete'.t() + ` ${this.resource}?`)) {
            return false;
        }
        try {
            this.loading = true;
            const endpoint = this.deleteEndpoint || `${this.resource}.delete`;
            const response = await this.apiService.back.delete(endpoint, { routeParams: { id } });
            if (response && response.success) {
                // Remove the item from the local list
                this.data = this.data.filter(c => c.id !== id);
                this.notifyService.notify(('crud.deletedSuccessfully'.t() + ` ${this.resource}`), 'info');
                this.$emit('crud-table:item-deleted', { id, resource: this.resource });
                // Refresh limit checks after deletion
                this.checkAccountLimits();
                return true;
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'crud.failedToDelete'.t(), 'error');
                return false;
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('crud.failedToDelete'.t(), 'error');
            return false;
        }
        finally {
            this.loading = false;
        }
    }
    navigateToEdit(id) {
        if (this.editRoute) {
            // Replace :id placeholder with actual ID
            const url = this.editRoute.replace(':id', id);
            // Use SiteMenu.goto for navigation
            component_2.SiteMenu.goto.bind(this)(url);
        }
    }
    navigateToPreview(id) {
        if (this.previewRoute) {
            // Replace :id placeholder with actual ID
            const url = this.previewRoute.replace(':id', id);
            // Use SiteMenu.goto for navigation
            component_2.SiteMenu.goto.bind(this)(url);
        }
    }
    async checkAccountLimits() {
        if (!this.resource)
            return;
        try {
            const limitCheck = await this.accountLimitService.checkResourceLimitWithCount(this.resource);
            this.limitReached = !limitCheck.canCreate;
            this.limitTooltip = limitCheck.message || '';
        }
        catch (error) {
            console.error('Error checking account limits:', error);
        }
    }
    async navigateToAdd() {
        if (!this.addRoute)
            return;
        // Check limits before navigation
        const limitCheck = await this.accountLimitService.checkResourceLimitWithCount(this.resource);
        if (!limitCheck.canCreate) {
            this.accountLimitService.showLimitExceededPopup(limitCheck.message || 'limits.upgrade.message'.t());
            return;
        }
        component_2.SiteMenu.goto.bind(this)(this.addRoute);
    }
    setupActions() {
        const externalActions = this.actions ? [...this.actions] : [];
        const actions = [];
        const isSuperAdmin = component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN;
        const policy = component_1.DefaultLayout.USER.acl;
        // Add preview action if previewRoute is provided
        if (this.previewRoute) {
            actions.push({
                key: 'preview',
                icon: 'simple-icon-eye',
                label: '',
                variant: 'secondary',
                tooltip: 'crud.preview'.t(),
                handler: async (id) => {
                    this.navigateToPreview(id);
                },
                filter: (row) => {
                    return isSuperAdmin || (0, acl_helpers_1.checkACL)(`${this.resource}.${backendImport_1.ACL.aclActions.read}`, policy);
                }
            });
        }
        // Add edit action only if canEdit is true
        if (this.canEdit) {
            actions.push({
                key: 'edit',
                icon: 'simple-icon-pencil',
                label: '',
                variant: 'info',
                tooltip: 'crud.edit'.t(),
                handler: async (id) => {
                    this.navigateToEdit(id);
                },
                filter: (row) => {
                    if (this.forceItemEditable !== undefined && this.forceItemEditable('edit', row)) {
                        return true;
                    }
                    return isSuperAdmin || (0, acl_helpers_1.checkACL)(`${this.resource}.${backendImport_1.ACL.aclActions.write}`, policy) && !!this.editRoute;
                }
            });
        }
        // Add delete action only if canDelete is true
        if (this.canDelete) {
            actions.push({
                key: 'delete',
                icon: 'simple-icon-trash',
                label: '',
                variant: 'danger',
                tooltip: 'crud.delete'.t(),
                handler: async (id) => {
                    await this.deleteItem(id);
                },
                filter: (row) => {
                    if (this.forceItemEditable !== undefined && this.forceItemEditable('delete', row)) {
                        return true;
                    }
                    return isSuperAdmin || (0, acl_helpers_1.checkACL)(`${this.resource}.${backendImport_1.ACL.aclActions.delete}`, policy) && !!this.deleteEndpoint;
                }
            });
        }
        const builtInKeys = new Set(actions.map(a => a.key));
        this.actions = [...externalActions.filter(a => !builtInKeys.has(a.key)), ...actions];
    }
    initializeVisibleColumns() {
        // Initialize all columns as visible by default
        this.visibleColumns = this.columns.map(col => col.key);
    }
    setupTableControls() {
        // Look for table-controls child component and set it up
        const tableControls = this.querySelector('table-controls');
        if (tableControls && typeof tableControls.setAvailableColumns === 'function' && typeof tableControls.setVisibleColumns === 'function') {
            // Set available columns in the table controls
            tableControls.setAvailableColumns(this.columns);
            tableControls.setVisibleColumns(this.visibleColumns);
            // Listen for column changes from table-controls
            if (typeof tableControls.addEventListener === 'function') {
                tableControls.addEventListener('columns-changed', (event) => {
                    this.handleColumnsChanged(event);
                });
            }
        }
    }
    handleColumnsChanged(event) {
        const { visibleColumns } = event.detail;
        this.setVisibleColumns(visibleColumns);
    }
    // Method to set columns and reinitialize visibility
    setColumns(columns) {
        this.columns = Array.isArray(columns) ? columns : [];
        this.initializeVisibleColumns();
        this.syncWithTableControls();
    }
    // Method to set ACL permissions
    setPermissions(permissions) {
        if (permissions.canEdit !== undefined)
            this.canEdit = permissions.canEdit;
        if (permissions.canDelete !== undefined)
            this.canDelete = permissions.canDelete;
        this.setupActions();
    }
    // Method to toggle column visibility
    toggleColumnVisibility(columnKey, isVisible) {
        if (isVisible) {
            if (!this.visibleColumns.includes(columnKey)) {
                this.visibleColumns = [...this.visibleColumns, columnKey];
            }
        }
        else {
            this.visibleColumns = this.visibleColumns.filter(key => key !== columnKey);
        }
    }
    // Method to manually sync with child table-controls (useful when data changes)
    syncWithTableControls() {
        const tableControls = this.querySelector('table-controls');
        if (tableControls && typeof tableControls.setAvailableColumns === 'function' && typeof tableControls.setVisibleColumns === 'function') {
            tableControls.setAvailableColumns(this.columns);
            tableControls.setVisibleColumns(this.visibleColumns);
        }
    }
    // Override setVisibleColumns to sync with table-controls
    setVisibleColumns(columnKeys) {
        this.visibleColumns = columnKeys.filter(key => this.columns.some(col => col.key === key));
        this.syncWithTableControls();
    }
    // Method to get currently visible columns
    getVisibleColumns() {
        return this.columns.filter(col => this.visibleColumns.includes(col.key));
    }
    // Get the empty message to display
    get effectiveEmptyMessage() {
        return this.emptyMessage || 'crud.noEntries'.t();
    }
    // Add property change handlers for reactive updates
    perPageChanged(oldValue, newValue) {
        // Only process changes after component is ready AND initialization is complete AND oldValue exists
        // Skip if parent is managing data externally
        if (this.isComponentReady && !this.isInitializing && oldValue !== newValue && oldValue !== undefined) {
            // Don't trigger load if parent is providing data externally
            if (this.data && this.data.length > 0) {
                return;
            }
            this.currentPage = 1; // Reset to first page when perPage changes
            this.loadData();
        }
        else {
        }
    }
    customQueryParamsChanged(oldValue, newValue) {
        // Only process changes after component is ready and initialization is complete
        // Skip if parent is managing data externally  
        if (this.isComponentReady && !this.isInitializing && oldValue !== undefined && JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
            // Don't trigger load if parent is providing data externally
            if (this.data && this.data.length > 0) {
                return;
            }
            this.currentPage = 1; // Reset to first page when query params change
            this.loadData();
        }
        else {
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
};
exports.CrudTable = CrudTable;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "resource", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "title", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "queryParam", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "showSearch", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CrudTable.prototype, "showPagination", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "searchPlaceholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "indexEndpoint", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "listEndpoint", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "deleteEndpoint", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "editRoute", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "addRoute", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "previewRoute", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "addText", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "emptyMessage", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CrudTable.prototype, "autoLoad", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CrudTable.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CrudTable.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CrudTable.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CrudTable.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CrudTable.prototype, "perPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], CrudTable.prototype, "customQueryParams", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], CrudTable.prototype, "onPageChanged", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], CrudTable.prototype, "onDataLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "canEdit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "canDelete", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "canAdd", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "noAdd", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "ready", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CrudTable.prototype, "limitReached", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CrudTable.prototype, "limitTooltip", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], CrudTable.prototype, "isItemUneditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], CrudTable.prototype, "forceItemEditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CrudTable.prototype, "columns", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CrudTable.prototype, "actions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CrudTable.prototype, "visibleColumns", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "pageParam", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "perPageParam", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "blockAdd", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CrudTable.prototype, "defaultQ", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], CrudTable.prototype, "actionsFilter", void 0);
exports.CrudTable = CrudTable = __decorate([
    (0, client_1.RWSView)('crud-table', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(AccountLimitService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof AccountLimitService_1.AccountLimitServiceInstance !== "undefined" && AccountLimitService_1.AccountLimitServiceInstance) === "function" ? _b : Object])
], CrudTable);
CrudTable.defineComponent();
